<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="no-data" v-if="!list.length">
        <van-image width="170px" height="auto" fit="fill" :src="noDataImg" />
        <div>{{ noDataMessage }}</div>
        <slot name="no-data"></slot>
      </div>
      <van-list
        v-if="list.length"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <slot></slot>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import noDataImg from "@/assets/images/img-default@2x.png";
export default {
  props: {
    list: {
      default() {
        return [];
      },
      type: Array,
    },
    noDataMessage: {
      default() {
        return "暂无数据";
      },
      type: String,
    },
  },
  data() {
    return {
      noDataImg: noDataImg,
      loading: false,
      finished: false,
      isLoading: false,
    };
  },
  methods: {
    reset() {
      this.isLoading = false;
      this.finished = false;
    },
    onLoad() {
      this.loading = true;
      this.$emit("onLoad");
    },
    onRefresh() {
      setTimeout((_) => {
        this.loading = false;
        this.finished = false;
        this.$emit("onRefresh");
      }, 800);
    },
    complete(res) {
      this.isLoading = false;
      this.loading = false;
      if (res.isLastPage) {
        this.finished = true;
      }
    },
    onFinish() {
      this.isLoading = false;
      this.loading = false;
      this.finished = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.no-data
  text-align center
  color #BBBBBB
  font-size 14px
  line-height 2
  padding-top 80px
  height calc(100vh - 50px - 245px - 50px - 80px)
>>> .van-pull-refresh
  overflow hidden
</style>
